module.exports = __webpack_public_path__ + "img/oval.d04c5893.png";